const version = "0.1.0";

export default version;
